<template>
    <div class="card w-100">
        <div class="card-body">
            <div class="d-flex flex-row">
                <h5><span class="text-primary">任务列表</span></h5>
            </div>
            <mini-table ref="taskBatchTable"
                        class="mt-1"
                        :items="rows"
                        need-model-fields
                        :entity-name="entityName"
                        :custom-vuex-name="taskConfig.customVuexName"
                        :fields="taskConfig.editFields"
                        disable-first-index-column
                        read-only sortable
                        with-custom-actions-end-of-row
                        @dataChange="dataChangeFlag++">
                <template #endOfRow="{row}">
                    <div class="d-flex flex-row" v-if="configs.viewInfos(row)">
                        <template v-for="(item, index) of configs.viewInfos(row)">
                            <template v-if="item.type === 'api_check'">
                                <api-check-validation
                                    v-if="item.needStatus===undefined || item.needStatus.some(o=>o===status)"
                                    :key="index"
                                    :api="item.api"
                                    :label="item.label"
                                    class="ml-1" popup
                                    read-only></api-check-validation><!--read only-->
                            </template>
                            <overlay-mini-table v-else
                                                class="ml-1"
                                                :key="index"
                                                lazyLoad
                                                :entity-name="item.entityName"
                                                :id="item.id"
                                                :title="item.title"
                                                :query-api="item.queryApi"
                                                :data="item.data"
                                                :fields="item.fields"
                                                :table-config="item.tableConfig">
                            </overlay-mini-table>
                        </template>
                    </div>
                </template>
            </mini-table>
            <div class="d-flex flex-row">
                <slot name="customAction" :status="status"></slot>
                <b-button :disabled="taskCompleteLoading || !isComplete" variant="outline-success"
                          class="ml-auto mt-1 mh_ col-4"
                          @click="completeTasks">
                    <b-spinner small v-show="taskCompleteLoading"></b-spinner>
                    提 交
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import OverlayMiniTable from "@/components/workflow/stuffs/OverlayMiniTable.vue";
import EmCommonApi from "@/mixin/em/common/api";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import ApiCheckValidation from "@/components/workflow/stuffs/ApiCheckValidation.vue";

export default {
    name: "WorkflowTaskBatch",
    mixins: [EmCommonApi, emCommonUtilMixin],
    components: {ApiCheckValidation, OverlayMiniTable, MiniTable},
    props: {
        /**
         * {
         *     'taskId':{
         *         name,
         *         editFields,
         *         customVuexName.
         *     }
         *     viewInfos,
         * }
         */
        configs: Object,
        rows: Array,
        entityName: String,
        completeBatchApi: String,
        callbackApi: String,
        endCallApi: String,
    },
    data() {
        return {
            taskCompleteLoading: false,
            dataChangeFlag: 0
        }
    },
    computed: {
        status() {
            if (this.rows && this.rows.length > 0) {
                return this.rows[0].status;
            }
            return '';
        },
        taskConfig() {
            let config = this.configs[this.status];
            return config ? config : {};
        },
        completeApiFinal() {
            return this.completeBatchApi ? this.completeBatchApi : process.env.VUE_APP_EM_WORKFLOW_URL + '/completeTaskBatch';
        },
        callbackApiFinal() {
            return this.callbackApi ? this.callbackApi : this.$store.state[this.entityName].callbackApi;
        },
        isComplete() {
            console.log('--refresh--', this.dataChangeFlag);
            return this.$refs.taskBatchTable && this.$refs.taskBatchTable.isInputCompete();
        },
    },
    methods: {
        completeTasks() {
            if (!this.isComplete) {
                return;
            }
            let forms = this.packCompleteForms();
            if (forms.length > 0) {
                this.taskCompleteLoading = true;
                this.$store.dispatch('api/post', {
                    url: this.completeApiFinal,
                    data: forms
                }).then(() => {
                    this.$message.success("提交成功");
                    this.$store.commit('workflow/setTaskListNeedRefresh', true);
                    this.$router.go(-1);
                }).finally(() => this.taskCompleteLoading = false);
            }
        },
        packCompleteForms() {
            let editData = this.$refs.taskBatchTable.columnEditData();
            let forms = [];
            if (editData.length > 0) {
                for (let item of editData) {
                    let row = this.rows.find(o => o.id === item.id);
                    forms.push({
                        taskId: row.workflowTask.taskInstanceId,
                        approved: this.getApprove(-1, item, row),
                        variables: item,
                        callbackApi: this.callbackApiFinal,
                        requests: this.packRequests(item),
                        endCallApi: this.endCallApi,
                    });
                }
            }
            return forms;
        },
        packRequests(item) {
            let requests = [];
            requests.push({
                url: `${this.$_emApiMixin_moduleBaseApi(this.entityName)}/${this.entityName}/selective`,
                httpType: 'put',
                entity: item
            })
            return requests;
        },
        getApprove(approve, variables, row) {
            let temp = approve;
            if (this.taskConfig.hasOwnProperty('setApprove')) {
                temp = this.taskConfig.setApprove(temp, variables, row);
            }
            return temp;
        },
    }
}
</script>

<style scoped>
.mh_ {
    max-height: 1.8rem;
}
</style>
